/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { nappiCodeIdGet } from '../fn/nappi-code/nappi-code-id-get';
import { NappiCodeIdGet$Params } from '../fn/nappi-code/nappi-code-id-get';
import { nappiCodePost } from '../fn/nappi-code/nappi-code-post';
import { NappiCodePost$Params } from '../fn/nappi-code/nappi-code-post';
import { NappiCodeRecordModel } from '../models/nappi-code-record-model';
import { NappiCodeRecordModelSearchResultModel } from '../models/nappi-code-record-model-search-result-model';
import { nappiCodeSearchNappiCodePost } from '../fn/nappi-code/nappi-code-search-nappi-code-post';
import { NappiCodeSearchNappiCodePost$Params } from '../fn/nappi-code/nappi-code-search-nappi-code-post';

@Injectable({ providedIn: 'root' })
export class MDINappiCodeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `nappiCodeSearchNappiCodePost()` */
  static readonly NappiCodeSearchNappiCodePostPath = '/NappiCode/SearchNappiCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nappiCodeSearchNappiCodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nappiCodeSearchNappiCodePost$Response(params?: NappiCodeSearchNappiCodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<NappiCodeRecordModelSearchResultModel>> {
    return nappiCodeSearchNappiCodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nappiCodeSearchNappiCodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nappiCodeSearchNappiCodePost(params?: NappiCodeSearchNappiCodePost$Params, context?: HttpContext): Observable<NappiCodeRecordModelSearchResultModel> {
    return this.nappiCodeSearchNappiCodePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<NappiCodeRecordModelSearchResultModel>): NappiCodeRecordModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `nappiCodeIdGet()` */
  static readonly NappiCodeIdGetPath = '/NappiCode/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nappiCodeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  nappiCodeIdGet$Response(params: NappiCodeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<NappiCodeRecordModel>> {
    return nappiCodeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nappiCodeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nappiCodeIdGet(params: NappiCodeIdGet$Params, context?: HttpContext): Observable<NappiCodeRecordModel> {
    return this.nappiCodeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<NappiCodeRecordModel>): NappiCodeRecordModel => r.body)
    );
  }

  /** Path part for operation `nappiCodePost()` */
  static readonly NappiCodePostPath = '/NappiCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nappiCodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nappiCodePost$Response(params?: NappiCodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return nappiCodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nappiCodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nappiCodePost(params?: NappiCodePost$Params, context?: HttpContext): Observable<string> {
    return this.nappiCodePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
